export default __webpack_public_path__ + "static/media/map-marker.aa0e9652.svg";